<div class="danhsach-phatdungcu-container">
  <!-- Main Card -->
  <div class="card main-card">
    <div class="card-header bg-gradient-dark text-white">
      <div class="d-flex align-items-center justify-content-between" style="width:100%">
        <div class="d-flex align-items-center">
          <i class="fas fa-box-open mr-2"></i>
          <strong>Danh sách tài liệu đã phát</strong>
        </div>
        <div class="header-actions">
          <div class="status-filter">
            <label class="mr-2 mb-0">Trạng thái:</label>
            <select class="form-control form-control-sm" [(ngModel)]="trangThaiPhat" (change)="search()">
              <option value="">-- Tất cả --</option>
              <option value="1">Đã phát</option>
              <option value="0">Chưa phát</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body p-0">
      <div class="data-content-wrapper">
        <!-- Vertical Toolbar -->
        <div class="vertical-toolbar" *ngIf="quyen_them===true">
          <button class="toolbar-btn btn-add" (click)="adddata()" title="Thêm mới">
            <i class="fas fa-plus"></i>
          </button>
          <button class="toolbar-btn btn-add-multiple" (click)="adddata_nhieu()" title="Thêm nhiều SP">
            <i class="fas fa-layer-group"></i>
          </button>
          <div class="toolbar-divider"></div>
          <button class="toolbar-btn btn-print" (click)="export('pdf')" title="In hóa đơn">
            <i class="fas fa-print"></i>
          </button>
          <button class="toolbar-btn btn-excel" (click)="export('xlsx')" title="Xuất Excel">
            <i class="fas fa-file-excel"></i>
          </button>
        </div>

        <!-- Table Wrapper -->
        <div class="table-wrapper-horizontal">
          <table class="table table-hover table-sm mb-0">
            <thead class="thead-light">
              <tr>
                <th style="min-width:60px;width:60px;text-align:center">
                  <input type="checkbox" [(ngModel)]="TatCa" (click)="TichTatCa()" />
                </th>
                <th style="min-width:60px;width:60px;text-align:center">STT</th>
                <th style="min-width:130px;width:130px">Ngày nộp</th>
                <th style="min-width:130px;width:130px">Ngày phát</th>
                <th style="min-width:120px;width:120px">Quyển số</th>
                <th style="min-width:120px;width:120px">Số phiếu</th>
                <th style="min-width:250px;width:250px">Tên </th>
                <th style="min-width:100px;width:100px;text-align:right">Số lượng</th>
                <th style="min-width:120px;width:120px">Thu phí</th>
                <th style="min-width:150px;width:150px;text-align:right">Số tiền</th>
                <th style="min-width:130px;width:130px">Phương thức</th>
                <th style="min-width:150px;width:150px">Kho</th>
                <th style="min-width:150px;width:150px">Ngày sửa</th>
                <th style="min-width:130px;width:130px">Người sửa</th>
                <th style="min-width:200px;width:200px">Ghi chú</th>
                <th style="min-width:120px;width:120px;text-align:center">Thao tác</th>
              </tr>
              <!-- Filter Row -->
              <tr class="filter-row">
                <td></td>
                <td></td>
                <td>
                  <input class="form-control form-control-sm" type="text"
                         [(ngModel)]="TimKiems.NgayThuTien" placeholder="Tìm..." (keydown)="onKeydownEvent($event)">
                </td>
                <td>
                  <input class="form-control form-control-sm" type="text"
                         [(ngModel)]="TimKiems.Ngay" placeholder="Tìm..." (keydown)="onKeydownEvent($event)">
                </td>
                <td>
                  <input class="form-control form-control-sm" type="text"
                         [(ngModel)]="TimKiems.QuyenSo" placeholder="Tìm..." (keydown)="onKeydownEvent($event)">
                </td>
                <td>
                  <input class="form-control form-control-sm" type="number"
                         [(ngModel)]="TimKiems.SoPhieu" placeholder="Tìm..." (keydown)="onKeydownEvent($event)">
                </td>
                <td>
                  <input class="form-control form-control-sm" type="text"
                         [(ngModel)]="TimKiems.Ten" placeholder="Tìm..." (keydown)="onKeydownEvent($event)">
                </td>
                <td>
                  <input class="form-control form-control-sm" type="number"
                         [(ngModel)]="TimKiems.SoLuong" placeholder="Tìm..." (keydown)="onKeydownEvent($event)">
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  <input class="form-control form-control-sm" type="text"
                         [(ngModel)]="TimKiems.KhoHang" placeholder="Tìm..." (keydown)="onKeydownEvent($event)">
                </td>
                <td></td>
                <td>
                  <input class="form-control form-control-sm" type="text"
                         [(ngModel)]="TimKiems.ModifiedBy" placeholder="Tìm..." (keydown)="onKeydownEvent($event)">
                </td>
                <td>
                  <input class="form-control form-control-sm" type="text"
                         [(ngModel)]="TimKiems.GhiChu" placeholder="Tìm..." (keydown)="onKeydownEvent($event)">
                </td>
                <td></td>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let u of datas" 
                  [ngClass]="{'chua-phat-row': !u.Ngay, 'data-row': true}">
                <td style="text-align:center">
                  <input type="checkbox" [(ngModel)]="u.Tich" />
                </td>
                <td style="text-align:center">
                  <span class="badge badge-secondary">{{u.STT}}</span>
                </td>
                <td>
                  <a (click)="editdata(u)" class="link-primary">
                    <small>{{u.NgayThuTien | date:'dd/MM/yyyy'}}</small>
                  </a>
                </td>
                <td>
                  <a (click)="editdata(u)" class="link-primary">
                    <span *ngIf="u.Ngay" class="badge badge-success">
                      <i class="fas fa-check mr-1"></i>{{u.Ngay | date:'dd/MM/yyyy'}}
                    </span>
                    <span *ngIf="!u.Ngay" class="badge badge-warning">
                      <i class="fas fa-exclamation-triangle mr-1"></i>Chưa phát
                    </span>
                  </a>
                </td>
                <td>
                  <a (click)="editdata(u)" class="link-primary">{{u.QuyenSo}}</a>
                </td>
                <td>
                  <a (click)="editdata(u)" class="link-primary">
                    <span class="badge badge-info">{{u.SoPhieu}}</span>
                  </a>
                </td>
                <td>
                  <a (click)="editdata(u)" class="link-primary">
                    <strong>{{u.TenSanPham}}</strong>
                  </a>
                </td>
                <td style="text-align:right">
                  <a (click)="editdata(u)" class="link-primary">
                    <span class="quantity-badge">{{u.SoLuong | number}}</span>
                  </a>
                </td>
                <td>
                  <a (click)="editdata(u)" class="link-primary">
                    <small>{{u.DangKyS}}</small>
                  </a>
                </td>
                <td style="text-align:right">
                  <a (click)="editdata(u)" class="link-primary">
                    <span class="amount-text">{{u.SoTien | number:'1.0-0'}}</span>
                  </a>
                </td>
                <td>
                  <a (click)="editdata(u)" class="link-primary">
                    <small>{{u.PhuongThucS}}</small>
                  </a>
                </td>
                <td>
                  <a (click)="editdata(u)" class="link-primary">{{u.KhoHang}}</a>
                </td>
                <td>
                  <a (click)="editdata(u)" class="link-primary">
                    <small class="text-muted">{{u.Modified | date:'dd/MM/yyyy HH:mm'}}</small>
                  </a>
                </td>
                <td>
                  <a (click)="editdata(u)" class="link-primary">
                    <small>{{u.ModifiedBy}}</small>
                  </a>
                </td>
                <td>
                  <a (click)="editdata(u)" class="link-primary">
                    <small class="text-muted">{{u.GhiChu}}</small>
                  </a>
                </td>
                <td style="text-align:center">
                  <div class="action-buttons">
                    <button *ngIf="quyen_them===true" class="btn btn-sm btn-outline-primary" 
                            (click)="editdata(u)" title="Sửa">
                      <i class="fas fa-edit"></i>
                    </button>
                    <button class="btn btn-sm btn-outline-danger" 
                            (click)="deletedata(u.Id)" title="Xóa">
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </div>
                </td>
              </tr>

              <tr *ngIf="!datas || datas.length === 0">
                <td colspan="16" class="text-center text-muted py-4">
                  <i class="fas fa-inbox fa-2x mb-2 d-block"></i>
                  Chưa có dữ liệu phát dụng cụ
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="card-footer bg-white border-top">
      <div class="d-flex justify-content-between align-items-center">
        <!-- Pagination -->
        <div class="pagination-wrapper">
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [ngClass]="{disabled: currentPage === 1}">
              <a class="page-link" (click)="setPage(1)"><<</a>
            </li>
            <li class="page-item" [ngClass]="{disabled: currentPage === 1}">
              <a class="page-link" (click)="setPage(currentPage - 1)"><</a>
            </li>
            <li class="page-item" *ngFor="let page of pages" [ngClass]="{active: currentPage === page.Id}">
              <a class="page-link" (click)="setPage(page.Id)">{{page.Id}}</a>
            </li>
            <li class="page-item" [ngClass]="{disabled: currentPage === totalPages}">
              <a class="page-link" (click)="setPage(currentPage + 1)">></a>
            </li>
            <li class="page-item" [ngClass]="{disabled: currentPage === totalPages}">
              <a class="page-link" (click)="setPage(totalPages)">>></a>
            </li>
            <li class="page-item">
              <input type="number" class="form-control form-control-sm page-size-input" 
                     [(ngModel)]="pageSize" (blur)="search1()" />
            </li>
            <li class="page-item">
              <span class="page-link"><strong>Tổng: {{totalItems | number}}</strong></span>
            </li>
          </ul>
        </div>

       
      </div>
    </div>
  </div>
</div>

<!-- Modals -->
<bs-modal #myModal class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="myModal.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-danhmuc-xuatkhoedit #dteChung (save)="saveModal($event)"></app-danhmuc-xuatkhoedit>
  </bs-modal-body>
</bs-modal>

<bs-modal #myModalNhieuSP class="modal fade show in" [cssClass]="'modal800'" [backdrop]="'static'" [keyboard]="true">
  <div class="modal-header">
    <h4 class="modal-title">{{modalTitle}}</h4>
    <button type="button" aria-label="Dismiss" class="close" (click)="myModalNhieuSP.close()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <bs-modal-body>
    <app-danhmuc-xuatkhonhieuedit #dteNhieuSP (save)="saveModal($event)"></app-danhmuc-xuatkhonhieuedit>
  </bs-modal-body>
</bs-modal>
